export default "__VITE_ASSET__DNcTtCj6__"